import { forwardRef } from 'react';
import { Form } from 'antd';
import FormInputField, { FormInputFieldProps } from '@shared/components/FormInput/FormInputField';

// Keep the existing form validation and value store, but render the same input
// and Info error tooltip as Admin's React Hook Form fields.
const UserFormInput = forwardRef<HTMLInputElement | HTMLTextAreaElement, FormInputFieldProps>((props, ref) => {
  const { errors } = Form.Item.useStatus();
  return <FormInputField {...props} ref={ref} error={errors.map(String).join(' ')} />;
});

UserFormInput.displayName = 'UserFormInput';
export default UserFormInput;
